import { type ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { ROUTES } from '@/constants/routes'
import type { UserRole } from '@/types/auth.types'

interface Props {
  /** Roles allowed to access this route */
  roles: UserRole[]
  children: ReactNode
  /** Redirect target when role not allowed — defaults to HOME */
  fallback?: string
}

/** Render children only for users with one of the allowed roles */
export function RoleRoute({ roles, children, fallback = ROUTES.HOME }: Props) {
  const { user } = useAuth()

  if (!user || !roles.includes(user.role)) {
    return <Navigate to={fallback} replace />
  }

  return <>{children}</>
}
